import { AudioLines } from 'lucide-react';
import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import { cleanHtml } from '../../../../utils/stringHelper';
import styles from "../../cards.module.scss"
function ResourceListItem({ resource, handleClickResource, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGridLarge : ''}`}
      onClick={handleClickResource}>
      <div className="h-full flex flex-row gap-x-5">
        <img
          className="h-32 w-32 object-cover shadow-md block rounded-md"
          src={resource.main_image ? resource.main_image.file : getImage('img-ph.png')}
          alt={resource.main_image ? resource.main_image.label : 'Non renseignée'}
        />

        <div className={styles.contentContainer}>
          <div className={styles.topInfo}>
            <p className={styles.title}>{resource.title}</p>
            <div
              dangerouslySetInnerHTML={{ __html: cleanHtml(resource.description) }}
              className={styles.subtitle}
            />
          </div>

          <div className={styles.tagList}>
            <Tag tag={getConstant('melismes.common.statusTypes', resource.status)} />
            <Tag tag={getConstant('melismes.resourceTypes', resource.type)} rounded />
            {resource.program && (
              <Tag
                tag={{
                  label: resource.program.title,
                  bgColor: 'bg-slate-700',
                  icon: AudioLines
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResourceListItem;
